import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_WIDTH = 8;
const DEFAULT_HEIGHT = 8;

function IconStoryPack({ width, color }: Omit<IconProps, "height" | "class">) {
    const height = width! * DEFAULT_HEIGHT / DEFAULT_WIDTH;

    return (
        <svg width={width} height={height} viewBox="0 0 8 8">
            <path d="M6 0a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM1 6a1 1 0 0 0 1 1h1.5V4.5H1zm6-1.5H4.5V7H6a1 1 0 0 0 1-1V4.5zM2 1a1 1 0 0 0-1 1v1.5h2.5V1zm2.5 2.5H7V2a1 1 0 0 0-1-1H4.5v2.5z" fill={color} fill-rule="nonzero"/>
        </svg>
    );
}

IconStoryPack.defaultProps = {
    width: DEFAULT_WIDTH,
    color: "var(--teflon)"
};

export default IconStoryPack;
